import { useWindowDimensions } from 'react-native';

import { BREAKPOINTS } from '@garnish/constants';
import type { MinWidthAttributes } from './types';

export const useCheckMinWidth = (
  breakpoints = BREAKPOINTS,
): MinWidthAttributes => {
  const { width } = useWindowDimensions();

  return usePrimedCheckMinWidth(width, breakpoints);
};

export const usePrimedCheckMinWidth = (
  width: number,
  breakpoints = BREAKPOINTS,
): MinWidthAttributes => {
  const minWidth = makeMinWidthChecker(width);

  return getMinWidthConditionalBlock(minWidth, breakpoints);
};

export const makeMinWidthChecker = (
  currentScreenWidth: number,
): ((breakpoint: number) => boolean) => {
  return (breakpoint: number) => {
    return breakpoint < currentScreenWidth;
  };
};

export const getMinWidthConditionalBlock = (
  minWidth: (breakpoint: number) => boolean,
  breakpoints = BREAKPOINTS,
): MinWidthAttributes => ({
  of: minWidth,
  mobile: minWidth(breakpoints[0].MIN),
  tablet: minWidth(breakpoints[1].MIN),
  desktop: minWidth(breakpoints[2].MIN),
  largeDisplay: minWidth(breakpoints[3].MIN),
});
